import { render, staticRenderFns } from "./ListagemContratacaoFreteHeader.vue?vue&type=template&id=5eb7b684"
import script from "./ListagemContratacaoFreteHeader.vue?vue&type=script&lang=js"
export * from "./ListagemContratacaoFreteHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports